/**
 * Utilities for interacting with the Disqus API.
 *
 * @type {Object}
 */

/* eslint-disable */

export const disqusUtils = {
  /**
   * Add the Disqus embed script to the page.
   *
   * @param {string} shortname Disqus forum shortname.
   * @param {string} domain Disqus domain to load the script from (probably disqus.com).
   * @param {Number} timestamp Timestamp to add to the script element.
   */
  addScript: function(shortname, domain, timestamp) {

    const script = document.createElement('script');
    script.src = 'https://' + shortname + '.' + domain + '/embed.js';
    script.setAttribute('data-timestamp', timestamp);

    const count = document.createElement('script');
    count.src = 'https://' + shortname + '.' + domain + '/count.js';
    count.setAttribute('data-timestamp', timestamp);
    count.setAttribute('id', 'dsq-count-scr');

    (document.head || document.body).appendChild(script);
    (document.head || document.body).appendChild(count);
  },

  /**
   * Set global variables that Disqus uses.
   *
   * `disqus_url` and `disqus_identifier` are named as in the WordPress plugin.
   *
   * @param {string} url Canonical URL Disqus should use.
   * @param {string} identifier Unique ID for the page.
   * @param {string} title Unique title for the page.
   */
  setGlobalConfig: function(url, identifier, title) {
    window.disqus_url = url;
    window.disqus_identifier = identifier;
    window.disqus_title = title;

    /**
     * This function is called from within Disqus to set properties on its own
     * object. Here we make sure the function uses the globals we just set.
     */
    window.disqus_config = function () {
      this.page.url        = window.disqus_url;
      this.page.identifier = window.disqus_identifier;
      this.page.disqus_title = window.disqus_title;
    }
  },
}
